import { GridRenderCellParams } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import { cyan, purple, yellow } from "@mui/material/colors";
import { DataRow } from "../types";

const COMPANY_TYPE_CHIP_CONFIGS = {
  GHQ: { label: "GHQ", color: yellow[100], fullLabel: "Global Headquarters" },
  CP: { label: "CP", color: purple[50], fullLabel: "Corporate Parent" },
  DP: { label: "DP", color: cyan[50], fullLabel: "Domestic Parent" },
};

export const CompanyTypeCell = (params: GridRenderCellParams<DataRow>) => {
  const { isGhq, isGp, isDp } = params.row;
  const companyTypeChipConfigs = [];

  if (isGhq) companyTypeChipConfigs.push(COMPANY_TYPE_CHIP_CONFIGS.GHQ);
  if (isGp) companyTypeChipConfigs.push(COMPANY_TYPE_CHIP_CONFIGS.CP);
  if (isDp) companyTypeChipConfigs.push(COMPANY_TYPE_CHIP_CONFIGS.DP);

  const tooltipValue = companyTypeChipConfigs
    .map((config) => config.fullLabel)
    .join(", ");

  return (
    <Tooltip title={tooltipValue} placement="bottom">
      <Stack direction="row" spacing={1}>
        {companyTypeChipConfigs.map((chipConfig) => (
          <Chip
            key={chipConfig.label}
            label={chipConfig.label}
            size="small"
            sx={{ backgroundColor: chipConfig.color }}
          />
        ))}
      </Stack>
    </Tooltip>
  );
};
